<template>
  <span class="infotip" @mouseenter="open = true" @mouseleave="open = false">
    <button
      type="button"
      class="infotip-btn"
      :aria-label="text"
      @click.stop="open = !open"
      @focus="open = true"
      @blur="open = false"
    >
      <AppIcon name="about" :size="13" />
    </button>
    <span v-if="open" class="infotip-bubble" role="tooltip">{{ text }}</span>
  </span>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import AppIcon from '../../../../components/AppIcon.vue'

// Hover/focus tooltip on tricky fields (limits, formats, examples) — design 1c.
defineProps<{ text: string }>()
const open = ref(false)
</script>

<style scoped>
.infotip { position: relative; display: inline-flex; align-items: center; }
.infotip-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  padding: 0;
  color: var(--color-text-tertiary);
  cursor: help;
}
.infotip-btn:hover { color: var(--color-text-secondary); }
.infotip-bubble {
  position: absolute;
  bottom: calc(100% + 6px);
  left: 50%;
  transform: translateX(-50%);
  z-index: 20;
  width: max-content;
  max-width: 260px;
  padding: var(--space-2) var(--space-3);
  border-radius: var(--radius-md);
  background: var(--color-bg-inverse);
  color: var(--color-text-inverse);
  font-size: var(--fs-xs);
  font-weight: var(--fw-regular);
  line-height: var(--lh-normal);
  box-shadow: var(--shadow-lg);
  white-space: normal;
}
</style>
